import React from 'react';
import { styled } from '@teko/ds-desktop';
import { getComponentSize } from '../../helpers/index.es.js';
import { t } from '../../i18n.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

const background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgzNkMzOC4yMDkxIDAgNDAgMS43OTA4NiA0MCA0VjM1LjgzODdDNDAgMzcuNTE1OCAzOC4wNjAxIDM4LjQ0ODEgMzYuNzUwNiAzNy40MDA1TDM2LjI0OTQgMzYuOTk5NUMzNS41MTkgMzYuNDE1MiAzNC40ODEgMzYuNDE1MiAzMy43NTA2IDM2Ljk5OTVMMzEuMjQ5NCAzOS4wMDA1QzMwLjUxOSAzOS41ODQ4IDI5LjQ4MSAzOS41ODQ4IDI4Ljc1MDYgMzkuMDAwNUwyNi4yNDk0IDM2Ljk5OTVDMjUuNTE5IDM2LjQxNTIgMjQuNDgxIDM2LjQxNTIgMjMuNzUwNiAzNi45OTk1TDIxLjI0OTQgMzkuMDAwNUMyMC41MTkgMzkuNTg0OCAxOS40ODEgMzkuNTg0OCAxOC43NTA2IDM5LjAwMDVMMTYuMjQ5NCAzNi45OTk1QzE1LjUxOSAzNi40MTUyIDE0LjQ4MSAzNi40MTUyIDEzLjc1MDYgMzYuOTk5NUwxMS4yNDk0IDM5LjAwMDVDMTAuNTE5IDM5LjU4NDggOS40ODEwNSAzOS41ODQ4IDguNzUwNjEgMzkuMDAwNUw2LjI0OTM5IDM2Ljk5OTVDNS41MTg5NSAzNi40MTUyIDQuNDgxMDUgMzYuNDE1MiAzLjc1MDYxIDM2Ljk5OTVMMy4yNDkzOSAzNy40MDA1QzEuOTM5ODYgMzguNDQ4MSAwIDM3LjUxNTggMCAzNS44Mzg3VjRaIgogICAgZmlsbD0iI0ZGREU2NyIgLz4KPC9zdmc+";
const SIZE = {
  s: {
    badge: 36,
    discountText: 8,
    percentText: 13
  },
  m: {
    badge: 40,
    discountText: 10,
    percentText: 15
  }
};
const FlashSaleBadge = ({
  discountPercent
}) => {
  const { isMobile } = useDevice();
  const size = getComponentSize(isMobile);
  return discountPercent ? /* @__PURE__ */ React.createElement(DiscountInfo, {
    size,
    background
  }, /* @__PURE__ */ React.createElement(DiscountText, {
    size
  }, t("GI\u1EA2M")), /* @__PURE__ */ React.createElement(PercentText, {
    size
  }, discountPercent, "%")) : null;
};
const DiscountText = styled.div(({ size }) => `
    font-weight: 700;
    color: #663009;
    line-height: 12px;
    font-size: ${SIZE[size].discountText}px;
`);
const PercentText = styled.div(({ size }) => `
    font-weight: 700;
    font-size: ${SIZE[size].percentText}px;
    line-height: 18px;
    color: #ee112e;
`);
const DiscountInfo = styled.div(({ size, background: background2 }) => `
    width: ${SIZE[size].badge}px;
    height: ${SIZE[size].badge}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url("${background2}");
    background-repeat: no-repeat;
    background-size: cover;
`);

export { FlashSaleBadge };
